
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import MeditationAudioViewModel from '@models/meditations/create/meditationAudioViewModel';
import { speechErrorMessage } from '@/api/dataSource/api/Spirit/Admin/Services/SpeechService';

@Component
export default class SpeechAudioControls extends Vue {
  @Prop({ required: true }) item: MeditationAudioViewModel;
  @Prop({ type: Boolean, default: false }) disabled: boolean;
  @Prop({ type: Boolean, default: false }) dirty: boolean;
  loading = false;
  error = '';
  message = '';
  private disposed = false;
  get hasText(): boolean { return !!(this.item.description || '').trim(); }
  get audioReady(): boolean { return !!(this.item.femaleUrl && this.item.maleUrl); }
  get hasAnyAudio(): boolean { return !!(this.item.femaleUrl || this.item.maleUrl); }
  get actionLabel(): string {
    if (this.loading) return 'Готовим озвучку…';
    if (this.audioReady) return 'Пересоздать';
    if (this.error) return 'Повторить озвучку';
    return this.hasAnyAudio ? 'Дополнить озвучку' : 'Озвучить фразу';
  }
  @Watch('item')
  onItemChanged() {
    this.error = '';
    this.message = '';
  }
  beforeDestroy() {
    this.disposed = true;
    if (this.loading) this.$emit('busy', false);
  }
  async generate(force: boolean = false) {
    if (this.disposed || this.loading || this.disabled || this.dirty || !this.item.id || !this.hasText) return;
    const requestedItem = this.item;
    const requestedId = requestedItem.id;
    this.loading = true;
    this.error = '';
    this.message = '';
    this.$emit('busy', true);
    try {
      const result = await this.$api.SpeechService.generateAsync(requestedId, force);
      if (this.disposed) return;
      requestedItem.femaleUrl = result.femaleUrl;
      requestedItem.maleUrl = result.maleUrl;
      requestedItem.speechNeedsUpdate = false;
      if (this.item === requestedItem) this.message = result.generated === 0 ? 'Озвучка уже актуальна' : 'Озвучка готова';
      this.$emit('generated', result);
    } catch (error) {
      if (!this.disposed && this.item === requestedItem) this.error = speechErrorMessage(error);
    } finally {
      this.loading = false;
      if (!this.disposed) this.$emit('busy', false);
    }
  }
}
